import { render, staticRenderFns } from "./Plastic.vue?vue&type=template&id=a82a6b84&"
import script from "./Plastic.vue?vue&type=script&lang=js&"
export * from "./Plastic.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/Product.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports